import React from 'react';
import { useAuth } from '../context/AuthContext';
import AnomalyDetectionPage from './AnomalyDetectionPage';
import AnomalyDetectionInterface from './AnomalyDetectionInterface';

export default function AnomalyRoute() {
  const { user, userProducts, plans, loading } = useAuth();

  if (loading) return null;

  const hasAnomaly =
    !!plans?.anomaly?.active ||
    userProducts?.some((p) => p.product_name === 'anomaly' && p.is_active);

  // If not logged in or no active plan, show the upsell/marketing page
  if (!user || !hasAnomaly) {
    return <AnomalyDetectionPage />;
  }

  // Active subscribers see the full interface
  return <AnomalyDetectionInterface />;
}
